/**
 * The lossless fall-back type (`week`, `vote`, `color_picker`, `team`, anything monday adds
 * next). No column of these types exists on an active board, so nothing was measured: the
 * conservative reading is presence only, which every value shape supports.
 */
import { IS_EMPTY, IS_NOT_EMPTY } from '../filter-conditions.js';
export const unsupportedFilterConditions = [IS_EMPTY, IS_NOT_EMPTY];
//# sourceMappingURL=filters.js.map